import { useSwitchProducts } from 'reactApp/ui/TariffSectionNew/hooks/useSwitchProducts';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import type { TariffsByTabProductsType } from 'reactApp/ui/TariffSectionNew/TariffsSection.types';
import { getMonthProductPrice } from 'reactApp/utils/priceHelpers';

interface UsePriceDif {
    products: TariffsByTabProductsType;
    familyProducts: TariffsByTabProductsType;
    activeTab?: ETabsName;
}

const initialProduct = {
    yearProduct: {},
};

export const usePriceDif = ({ products, familyProducts, activeTab }: UsePriceDif): number => {
    const { product } = useSwitchProducts({
        products: products || initialProduct,
        activeTab,
        withSwitch: false,
    });
    const { product: familyProduct } = useSwitchProducts({
        products: familyProducts || initialProduct,
        activeTab,
        withSwitch: false,
    });

    if (!familyProduct || !product) {
        return 0;
    }

    return Math.abs(Math.trunc(getMonthProductPrice(product) - getMonthProductPrice(familyProduct)));
};
